<template>
  <span>
    <template v-if="item.source === 'uploaded'">
      {{ $t("riskAssessment.source.uploaded") }}
    </template>
    <template v-else>
      {{
        item.kind === "advanced"
          ? $t("riskAssessment.kind.advancedShort")
          : $t("riskAssessment.kind.basicShort")
      }}
    </template>
  </span>
</template>
<script>
export default {
  props: ["item"],
};
</script>
